import { CTToastProvider } from "@nbcuniversal/ct-ui";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import App from "./App";
import { COGNITO_PATH } from "./Configurations";
import checkMaintenanceMode from "./MaintenanceModeUtil";
import ForgotUsernameForm from "./pods/components/forgot-username-form/ForgotUsernameForm";
import NotFoundPage from "./pods/components/not-found/NotFoundPage";
import RegistrationForm from "./pods/components/registration-form/RegistrationForm";

import "@fortawesome/fontawesome-free/css/all.min.css";

const router = createBrowserRouter([
  {
    path: "/",
    Component: () => {
      checkMaintenanceMode().then((maintenanceMode) => {
        if (maintenanceMode === false) {
          // eslint-disable-next-line max-len
          window.location.href = `${COGNITO_PATH.url}/oauth2/authorize?identity_provider=ALUMNI&redirect_uri=${COGNITO_PATH.redirectUri}&response_type=CODE&client_id=${COGNITO_PATH.clientId}&scope=openid`;
        }
        else {
          console.log("Portal is in Maintenance mode Not redirecting to login.");
        }
      });
      return null;
    },
  },
  {
    element: <App />,
    children: [
      {
        path: "/register",
        element: <RegistrationForm />,
      },
      {
        path: "/forgot-username",
        element: <ForgotUsernameForm />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <CTToastProvider>
    <RouterProvider router={router} />
  </CTToastProvider>,
);
